<script>
    import PlayerDiv from './PlayerDiv.svelte';
	export let batters = [];
	export let player_search = "";
	export let selected_team = "";
	export let pos_filter = "";
    export let showPlayerModal;
    export let game_strings = [];
    let sortableCols = {name:0, singles:0, doubles:0, triples:0, homeruns:0, runs:0, rbis:0, stolen_bases:0, fp:0, dk_fp:0};
    let sortClasses = ["sort-asc", "", "sort-desc"];
    function sortByX(key, sortableCols, players, toggle=1){
		if(sortableCols[key] == 1){
			sortableCols[key] = -1 * toggle;
		}
		else{
			sortableCols[key] = 1 * toggle;
		}
        //check if players has property stats
        if(key != "name" && players[0].stats){
            players.sort((a, b) => (a.stats[key] > b.stats[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        else{
            players.sort((a, b) => (a[key] > b[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        for(var prop in sortableCols){
			if(prop != key){
				sortableCols[prop] = 0;
			}
		}
        return {players:players, sortableCols:sortableCols};
	}
	function filterPlayer(batter, name_search, team_search, pos_search){
		return batter.name.toLowerCase().includes(name_search.toLowerCase()) && (team_search == "all" || batter.team == team_search) && (pos_search == "all" || batter.positions.includes(pos_search));
	}
</script>
<style>
    .sorter{
		padding-right: 30px;
		position:relative;
	}
    .padding-r-30{
        padding-right: 30px;
    }
    .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        left: 0px;
        background-color: #fff;
        z-index: 1;
    }
    .sticky-table-head{
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        background-color: #fff;
        z-index: 2;
    }
    .sticky-shadow-right{
        /*add webkit box shadow to fix safari bug*/
        -webkit-box-shadow: inset -1px 0px 0px 0px #ccc;
        box-shadow: inset -1px 0px 0px 0px #ccc;
    }
    .sticky-shadow-bottom{
        /*add webkit box shadow to fix safari bug*/
        -webkit-box-shadow: inset 0px -1px 0px 0px #ccc;
        box-shadow: inset 0px -1px 0px 0px #ccc;
    }
    .pointer{
		cursor:pointer;
	}
    .sorter.sort-asc:before{
		opacity: 1 !important;
	}
	.sorter.sort-desc:after{
		opacity: 1 !important;
	}
	.sorter:after,.sorter:before{
		position: absolute;
        bottom: 0em;
        display: block;
        opacity: .3;
		height:100%;
	}
	.sorter:after{
		right: .5em;
		content: "↓";
	}
	.sorter:before{
		right: 1em;
        content: "↑";
	}
</style>
<div class="table-responsive modern-card bg-light m-2 pb-2" style="max-height: 75vh;">
    <table class="table">
        <thead class="sticky-table-head sticky-shadow-bottom pt-2">
            <tr class="ps-2">
                <th on:click={()=>{let sortResult = sortByX("name", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}} class="sticky-col sticky-shadow-right {sortClasses[sortableCols["name"]+1]} padding-r-30 sorter pointer">Name</th>
                <th class="{sortClasses[sortableCols["singles"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("singles", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>Singles</th>
                <th class="{sortClasses[sortableCols["doubles"]+1]} padding-r-30 text-center  sorter pointer" on:click={()=>{let sortResult = sortByX("doubles", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>Doubles</th>
                <th class="{sortClasses[sortableCols["triples"]+1]}padding-r-30 text-center  sorter pointer" on:click={()=>{let sortResult = sortByX("triples", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>Triples</th>
                <th class="{sortClasses[sortableCols["homeruns"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("homeruns", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>Homeruns</th>
                <th class="{sortClasses[sortableCols["runs"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("runs", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>Runs</th>
                <th class="{sortClasses[sortableCols["rbis"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("rbis", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>RBIs</th>
                <th class="{sortClasses[sortableCols["stolen_bases"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("stolen_bases", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>Stolen Bases</th>
                <th class="{sortClasses[sortableCols["fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>{let sortResult = sortByX("fp", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>FD FP</th>
                <th class="{sortClasses[sortableCols["dk_fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>{let sortResult = sortByX("dk_fp", sortableCols, batters); batters = sortResult.players; sortableCols = sortResult.sortableCols;}}>DK FP</th></tr>
        </thead>
        <tbody>
            {#each batters as batter}
                {#if filterPlayer(batter, player_search, selected_team, pos_filter)}
                <tr>
                    <td class="pointer sticky-col sticky-shadow-right pb-0" on:click={()=>{showPlayerModal(batter)}}>
                        <PlayerDiv player_image={batter.img_thumb} player_positions={batter.positions} player_name={batter.name} detail_string={game_strings[batter.team]} player_inj_tag={batter.injury_tag}/>
                    </td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.singles}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.doubles}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.triples}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.homeruns}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.runs}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.rbis}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.stolen_bases}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.fp}</td>
                    <td class="align-bottom padding-r-30 text-center">{batter.stats.dk_fp}</td>
                </tr>
                {/if}
            {/each}
        </tbody>
    </table>
</div>

